export default "__VITE_ASSET__db798a90__"